<template>
   
    <span class="fa fa-plus-circle ratingselection" @click="favclicked()" :class="{'favcheck1':favrating===1,'favcheck2':favrating===2,'favcheck3':favrating===3}">                         
        <span v-if="label && favrating===1"> Ok</span>
        <span v-if="label && favrating===2"> Good</span>
        <span v-if="label && favrating===3"> Great</span>
    </span>    
  
</template>


<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";


  export default {
    props:["label","favourites","id"],      
    data: function() {
      return { 
          favrating:null
      }
    },
    methods: {      
      
      favclicked() {  
        this.favrating +=1      
        if(this.favrating >3)
          this.favrating = null               
          
        this.$emit("favclicked", {
          data: {rating:this.favrating}
        });        
      }

    },
    created(){
      this.favrating = this.favourites && this.favourites[this.id] ? this.favourites[this.id].rating : 0
    }

  };
</script>
 
<style>
  .ratingselection{
    padding-top:5px;
    padding-bottom:5px;
    font-weight: bold;
    font-size:24px;
  }
    .favcheck1 {
        color: orange;
    }

    .favcheck2 {
        color: blue;
    }

    .favcheck3 {
        color: green;
    }

</style>



// WEBPACK FOOTER //
// src/components/shared/FavSelection.vue